var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4799 4.81364C1.52635 4.76708 1.58152 4.73014 1.64227 4.70493C1.70301 4.67972 1.76813 4.66675 1.8339 4.66675C1.89967 4.66675 1.96479 4.67972 2.02554 4.70493C2.08628 4.73014 2.14146 4.76708 2.1879 4.81364L7.8339 10.4606L13.4799 4.81364C13.5264 4.76715 13.5816 4.73028 13.6423 4.70512C13.7031 4.67996 13.7682 4.66701 13.8339 4.66701C13.8996 4.66701 13.9647 4.67996 14.0255 4.70512C14.0862 4.73028 14.1414 4.76715 14.1879 4.81364C14.2344 4.86013 14.2713 4.91532 14.2964 4.97606C14.3216 5.0368 14.3345 5.1019 14.3345 5.16764C14.3345 5.23339 14.3216 5.29849 14.2964 5.35923C14.2713 5.41996 14.2344 5.47515 14.1879 5.52164L8.1879 11.5216C8.14146 11.5682 8.08628 11.6051 8.02553 11.6304C7.96479 11.6556 7.89967 11.6685 7.8339 11.6685C7.76813 11.6685 7.70301 11.6556 7.64227 11.6304C7.58152 11.6051 7.52635 11.5682 7.4799 11.5216L1.4799 5.52164C1.43334 5.4752 1.3964 5.42002 1.37119 5.35928C1.34598 5.29853 1.33301 5.23341 1.33301 5.16764C1.33301 5.10187 1.34598 5.03675 1.37119 4.97601C1.3964 4.91526 1.43334 4.86009 1.4799 4.81364Z",
    fill: "#0C3B5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.7e431f2fe0418b747ebae7520d2ffb41.svg";
export { ForwardRef as ReactComponent };